<template>
    <v-flex>
        <v-row>
            <v-col cols="12" :sm="12" :md="3" :lg="3">
                <chart-card-container icon="mdi-chart-donut-variant" title="Profile sections" :height="425">
                    <template slot="chart">
                        <sections-completion-radar :profile="profile" :height="350"
                                                   v-if="profile"></sections-completion-radar>
                    </template>
                </chart-card-container>
            </v-col>
            <v-col cols="12" :sm="12" :md="3" :lg="3">
                <chart-card-container icon="mdi-gauge-full" title="Profile content" :height="425">
                    <template slot="chart">
                      <v-flex class="d-flex ma-auto align-content-center justify-center">
                        <v-progress-circular
                                class="mt-12 ma-auto text-center"
                                :indeterminate="false"
                                :rotate="-90"
                                :value="getAvgProfileCompletion"
                                :width="12"
                                :size="220"
                                color="light-blue"
                        ><h3 class="display-3">{{ getAvgProfileCompletion }}%</h3></v-progress-circular>
                      </v-flex>

                    </template>
                </chart-card-container>
            </v-col>
            <v-col cols="12" :sm="12" :md="3" :lg="3">
                <!--        <chart-card-container icon="mdi-chart-line-variant" title="Active sections" :height="425" class="text-center ma-auto">-->
                <!--          <template slot="chart">-->
                <!--            <v-progress-circular-->
                <!--              class="mt-12 ma-auto text-center"-->
                <!--              :indeterminate="false"-->
                <!--              :rotate="-90"-->
                <!--              :value="getCurrentActiveSectionsPercentage"-->
                <!--              :width="12"-->
                <!--              :size="220"-->
                <!--              color="light-blue"-->
                <!--            >-->
                <!--              <h3 class="display-3">{{ getCurrentActiveSectionsPercentage }}%</h3>-->
                <!--            </v-progress-circular>-->
                <!--            <br>-->
                <!--            <br>-->
                <!--            <h5 class="body-1">({{ getCurrentActiveSections }} active sections out of 16)</h5>-->
                <!--          </template>-->
                <!--        </chart-card-container>-->
                <chart-card-container icon="mdi-timer-sand" title="Experience in current company" :height="425">
                    <template slot="chart">
                        <v-sheet class="text-center mt-10">
                            <v-row>
                                <v-col cols="12">
                                    <h3 class="light-blue--text display-3">{{getTimeInCompany}}</h3>
                                    <p>Years within the company</p>
                                </v-col>
                                <v-col cols="12">
                                    <h3 class="light-blue--text display-3">{{getTimeWithoutPromoting}}</h3>
                                    <p>Years without promotion</p>
                                </v-col>
                            </v-row>

<!--                            <h3 class="light-blue&#45;&#45;text display-3">{{getTimeAvgTimeWorkingCompanies}}</h3>-->
<!--                            <p>Average years working in companies</p>-->

<!--                            <v-row>-->
<!--                                <v-col>-->
<!--                                    <h3 class="light-blue&#45;&#45;text display-3">{{getTimeMinTimeWorkingCompanies}}</h3>-->
<!--                                  ProfileHeadingScoresStaff  <p>Min years working in companies</p>-->
<!--                                </v-col>-->
<!--                                <v-col>-->
<!--                                    <h3 class="light-blue&#45;&#45;text display-3">{{getTimeMaxTimeWorkingCompanies}}</h3>-->
<!--                                    <p>Max years working in companies</p>-->
<!--                                </v-col>-->
<!--                            </v-row>-->

                        </v-sheet>
                    </template>
                </chart-card-container>
            </v-col>
          <v-col cols="12" :sm="12" :md="3" :lg="3">
            <chart-card-container icon="mdi-timer-sand-complete" title="Previous experience" :height="425">
              <template slot="chart">
                <v-sheet class="text-center mt-10">
<!--                  <v-row>-->
<!--                    <v-col>-->
<!--                      <h3 class="light-blue&#45;&#45;text display-3">{{getTimeInCompany}}</h3>-->
<!--                      <p>Years within the company</p>-->
<!--                    </v-col>-->
<!--                    <v-col>-->
<!--                      <h3 class="light-blue&#45;&#45;text display-3">{{getTimeWithoutPromoting}}</h3>-->
<!--                      <p>Years without promotion</p>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
                  <h3 class="light-blue--text display-3">{{getTimeAvgTimeWorkingCompanies}}</h3>
                  <p>Average years in previous companies</p>

                  <v-row>
                    <v-col cols="">
                      <h3 class="light-blue--text display-3">{{getTimeMinTimeWorkingCompanies}}</h3>
                      <p>Minimum years in previous companies</p>
                    </v-col>
                    <v-col cols="">
                      <h3 class="light-blue--text display-3">{{getTimeMaxTimeWorkingCompanies}}</h3>
                      <p>Maximum years in previous companies</p>
                    </v-col>
                  </v-row>

                </v-sheet>
              </template>
            </chart-card-container>
          </v-col>
            <!--      <v-col cols="12" :sm="12" :md="3" :lg="3">-->
            <!--        <chart-card-container icon="mdi-timer-sand" title="Time last companies" :height="425">-->
            <!--          <template slot="chart">-->
            <!--            <v-sheet class="text-center mt-12">-->
            <!--              <h3 class="light-blue&#45;&#45;text display-3">{{getTimeAvgTimeWorkingCompanies}}</h3>-->
            <!--              <p>Average years working in companies</p>-->
            <!--            </v-sheet>-->
            <!--            <v-sheet class="text-center mt-12">-->
            <!--              <v-row>-->
            <!--                <v-col>-->
            <!--                  <h3 class="light-blue&#45;&#45;text display-3">{{getTimeMinTimeWorkingCompanies}}</h3>-->
            <!--                  <p>Min years working in companies</p>-->
            <!--                </v-col>-->
            <!--                <v-col>-->
            <!--                  <h3 class="light-blue&#45;&#45;text display-3">{{getTimeMaxTimeWorkingCompanies}}</h3>-->
            <!--                  <p>Max years working in companies</p>-->
            <!--                </v-col>-->
            <!--              </v-row>-->

            <!--            </v-sheet>-->
            <!--          </template>-->
            <!--        </chart-card-container>-->
            <!--      </v-col>-->
            <v-col cols="12" :sm="12" :md="12" :lg="12">
                <chart-card-container icon="mdi-chart-line-variant" title="Profile completion history" :height="425">
                    <template slot="chart">
                        <sections-completion-bars :profile="profile" :height="350"
                                                  v-if="profile"></sections-completion-bars>
                    </template>
                </chart-card-container>
            </v-col>

        </v-row>

    </v-flex>
</template>

<script>

    import ChartCardContainer from "../Charts/chartCardContainer";
    import SectionsCompletionRadar from "../Charts/Profile/sectionsCompletionRadar";
    import SectionsCompletionBars from "../Charts/Profile/sectionsCompletionBars";

    export default {
        name: "profileCompletion",
        components: {
            SectionsCompletionRadar,
            SectionsCompletionBars,
            ChartCardContainer
        },
        props: ['profile'],
        data() {
            return {
                selectedDates: [],
            }
        },
        computed: {
            getAvgProfileCompletion() {
                return Math.round(this.profile.edges.market.profileCompletion.total / 8);
            },
            getTimeInCompany() {
                return Math.round(this.profile.edges.times.timeInCompany / 12 * 10) / 10;
            },
            getTimeWithoutPromoting() {
                return Math.round(this.profile.edges.times.timeWithoutPromoting / 12 * 10) / 10;
            },
            getTimeAvgTimeWorkingCompanies() {
                return Math.round(this.profile.edges.times.avgTimeWorkingCompanies / 12 * 10) / 10;
            },
            getTimeMinTimeWorkingCompanies() {
                return Math.round(Math.min(...this.profile.edges.times.arrayTimeWorkingInCompanies) / 12 * 10) / 10;
            },
            getTimeMaxTimeWorkingCompanies() {
                return Math.round(Math.max(...this.profile.edges.times.arrayTimeWorkingInCompanies) / 12 * 10) / 10;
            },
            // getCurrentActiveSectionsPercentage(){
            //   return Math.round(this.profile.edges.market.sectionsWithContent.map(e => e.activeSections)[0] / 16 * 100);
            // },
            // getCurrentActiveSections(){
            //   return this.profile.edges.market.sectionsWithContent.map(e => e.activeSections)[0];
            // }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TabContents/profileCompletion.vue